import React from 'react';
import { MetricCard } from 'common/components';
import { formatCompactDuration, getDashboardMetricTheme } from 'components/InfoCards/dashboardMetricCard.utils';

type CallTimeData = {
    totalCount: number;
};

export type TotalCallTimeProps = {
    callData?: CallTimeData;
};

const TotalCallTime = ({ callData }: TotalCallTimeProps) => (
    <MetricCard
        id='total-call-time'
        label='Total Call Time'
        tooltip='Total duration of all calls in the selected range.'
        theme={getDashboardMetricTheme('Total Call Time')}
        primaryValue={formatCompactDuration(callData?.totalCount)}
        showPercent={false}
    />
);

export default TotalCallTime;
